import iconClose from "@/assets/img/details/close.png";

var imgS = ""
export function imgPreview(url) {
    let main = document.getElementsByClassName("home-container");
    let topContainer = document.createElement("div");
    topContainer.style.position = "fixed";
    topContainer.style.top = "0";
    topContainer.style.zIndex = "10000";
    topContainer.style.background = "rgba(0,0,0,0.80)";
    topContainer.style.height = "100vh";
    topContainer.style.width = "100%";
    topContainer.style.textAlign = "center";
    topContainer.className = "showBigImage";

    let imageContainer = document.createElement("div");
    imageContainer.style.width = window.innerWidth + "px";
    imageContainer.style.height = window.innerHeight + "px";
    imageContainer.style.margin = "0 auto";
    imageContainer.style.overflow = "auto";
    imageContainer.style.top = "50%";
    imageContainer.style.position = "relative";
    imageContainer.style.transform = "translateY(-50%)";

    let imageE = document.createElement("img");
    imageE.src = url;
    imageE.title = "鼠标滚轮滚动可缩放图片";
    // 加载完成执行
    imageE.onload = function () {
        imageE.style.position = "relative";
        imageE.style.top = "50%";
        imageE.style.width = "300px";
        imageE.style.height = "400px";
        imageE.style.transform = "translateY(-50%)";
        imageE.style.objectFit = "contain";
    };

    imgS = imageE;
    //添加鼠标滚轮事件缩放图片
    if (topContainer.addEventListener) {
        // IE9, Chrome, Safari, Opera
        topContainer.addEventListener("mousewheel", rollImg, false);
        // Firefox
        topContainer.addEventListener("DOMMouseScroll", rollImg, false);
    } else {
        // IE 6/7/8
        topContainer.attachEvent("onmousewheel", rollImg);
    }

    imageContainer.appendChild(imageE);
    topContainer.appendChild(imageContainer);
    main[0].appendChild(topContainer);

    //关闭按钮
    let imgClose = document.createElement("img");
    console.log(iconClose);
    imgClose.src = iconClose;
    imgClose.style.zIndex = "10001";
    imgClose.style.position = "fixed";
    imgClose.style.top = "5%";
    imgClose.style.right = "1%";
    imgClose.style.transform = "translateY(-50%)";
    imgClose.style.cursor = "pointer";
    imgClose.className = "showBigImage";
    //添加鼠标点击事件关闭显示大图
    imgClose.addEventListener("click", closeImageShow);
    main[0].appendChild(imgClose);
}
export function videoPreview(url) {
    let main = document.getElementsByClassName("home-container");
    let topContainer = document.createElement("div");
    topContainer.style.position = "fixed";
    topContainer.style.top = "0";
    topContainer.style.zIndex = "10000";
    topContainer.style.background = "rgba(0,0,0,0.80)";
    topContainer.style.height = "100vh";
    topContainer.style.width = "100%";
    topContainer.style.textAlign = "center";
    topContainer.className = "showBigImage";

    let imageContainer = document.createElement("div");
    imageContainer.style.width = window.innerWidth + "px";
    imageContainer.style.height = window.innerHeight + "px";
    imageContainer.style.margin = "0 auto";
    imageContainer.style.overflow = "auto";
    imageContainer.style.top = "50%";
    imageContainer.style.position = "relative";
    imageContainer.style.transform = "translateY(-50%)";

    let videoE = document.createElement("video");
    videoE.src = url;
    videoE.controls="controls" 
    videoE.autoplay="autoplay"
    videoE.style.width = "1100px";
    videoE.style.height = "600px";
    videoE.style.position = "relative";
    videoE.style.top = "50%";
    videoE.style.transform = "translateY(-50%)";

    imageContainer.appendChild(videoE);
    topContainer.appendChild(imageContainer);
    main[0].appendChild(topContainer);

    //关闭按钮
    let imgClose = document.createElement("img");
    imgClose.src = iconClose;
    imgClose.style.zIndex = "10001";
    imgClose.style.position = "fixed";
    imgClose.style.top = "5%";
    imgClose.style.right = "1%";
    imgClose.style.transform = "translateY(-50%)";
    imgClose.style.cursor = "pointer";
    imgClose.className = "showBigImage";
    //添加鼠标点击事件关闭显示大图
    imgClose.addEventListener("click", closeImageShow);
    main[0].appendChild(imgClose);
}
function closeImageShow() {
    let elementArr = document.getElementsByClassName("showBigImage");
    let main = document.getElementsByClassName("home-container");
    let count = elementArr.length;
    for (let i = 0; i < count; i++) {
        main[0].removeChild(elementArr[0]);
    }
}
function rollImg() {
    /* 获取当前页面的缩放比
          若未设置zoom缩放比，则为默认100%，即1，原图大小
      */
    var zoom = parseInt(imgS.style.zoom) || 100;
    /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
          wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
      */
    zoom += event.wheelDelta / 12;
    /* 如果缩放比大于0，则将缩放比加载到页面元素 */
    if (zoom >= 100) {
        imgS.style.zoom = zoom + "%";
    }
    /* 如果缩放比不大于0，则返回false，不执行操作 */
    return false;
}